import { render, staticRenderFns } from "./product-input.vue?vue&type=template&id=6ccc64b2&scoped=true&"
import script from "./product-input.vue?vue&type=script&lang=js&"
export * from "./product-input.vue?vue&type=script&lang=js&"
import style0 from "./product-input.vue?vue&type=style&index=0&id=6ccc64b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc64b2",
  null
  
)

export default component.exports